'use client'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface SelectOption {
  value: string
  label: string
  price: number
}

interface PricingSelectProps {
  options: SelectOption[]
  value: string
  onChange: (value: string) => void
  isAnnual?: boolean
  isDomainSelect?: boolean
}

/**
 * Pricing-specific select component that wraps the UI select with pricing display logic
 * Displays options with their associated prices, applying annual discount when applicable
 */
export function PricingSelect({
  options,
  value,
  onChange,
}: PricingSelectProps) {
  const selectedOption = options.find((option) => option.value === value)

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full bg-[#383838] border border-white/10 rounded-[12px] px-4 py-3 text-white hover:bg-white/15 transition-colors h-auto">
        <SelectValue>
          {selectedOption && (
            <div className="flex flex-col items-start gap-1">
              <span className="text-sm">
                {selectedOption.label.split('(')[0].trim()}
              </span>
              {selectedOption.label.includes('(') && (
                <span className="text-xs text-white/60">
                  ({selectedOption.label.split('(')[1]}
                </span>
              )}
            </div>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-[#383838] backdrop-blur-sm border border-white/10 rounded-[12px] text-white max-h-60">
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            className="text-white hover:bg-white/10 focus:bg-white/10 focus:text-white cursor-pointer rounded-[12px] py-3"
          >
            <div className="flex flex-col items-start w-full pr-6 gap-1">
              <span className="text-sm">
                {option.label.split('(')[0].trim()}
              </span>
              {option.label.includes('(') && (
                <span className="text-xs text-white/60">
                  ({option.label.split('(')[1]}
                </span>
              )}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
